import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GlobalSearchModel } from 'src/app/shared/models/common/global.search'

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  public searchTerm: BehaviorSubject<GlobalSearchModel> = new BehaviorSubject<GlobalSearchModel>(null);
  public changeGlobalBranch: BehaviorSubject<number> = new BehaviorSubject<number>(null);
}
